export default __webpack_public_path__ + "static/Gotham-Book-6789cea2d4543d117f884d12f74d82f6.woff2";